"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var styled_components_1 = __importStar(require("styled-components"));
var config_1 = require("../../../config");
var utils_1 = require("../../../utils");
var selectStyle = function (isSearchable, withDropdownIndicator, variant, hideTextCursor, isClean, minWidth, borderRadius, borderWidth, theme) {
    if (withDropdownIndicator === void 0) { withDropdownIndicator = true; }
    return ({
        singleValue: function (base) { return (__assign(__assign({}, base), { display: 'flex', alignItems: 'center', width: '100%', margin: 0, padding: '0 8px', color: isClean ? theme.TYPE_LIGHT_GREY : theme.TYPE_DARK_GREY, fontSize: config_1.variables.NEUE_FONT_SIZE.SMALL, fontWeight: config_1.variables.FONT_WEIGHT.MEDIUM, borderStyle: 'none', justifyContent: isClean ? 'flex-end' : 'flex-start', '&:hover': {
                cursor: hideTextCursor || !isSearchable ? 'pointer' : 'text',
            } })); },
        control: function (base, _a) {
            var isDisabled = _a.isDisabled, isFocused = _a.isFocused;
            var height = variant === 'small' ? '36px' : '48px';
            if (isClean)
                height = '22px';
            return __assign(__assign({}, base), { display: 'flex', alignItems: 'center', fontSize: config_1.variables.FONT_SIZE.SMALL, height: height, borderRadius: borderRadius + "px", borderWidth: borderWidth + "px", borderColor: theme.STROKE_GREY, borderStyle: isClean ? 'none' : 'solid', backgroundColor: 'transparent', boxShadow: 'none', '&:hover, &:focus': {
                    cursor: 'pointer',
                    borderRadius: borderRadius + "px",
                    borderWidth: borderWidth + "px",
                    borderColor: theme.STROKE_GREY,
                } });
        },
        valueContainer: function (base) {
            return (__assign(__assign({}, base), { border: 0, padding: isClean ? '0 3px 0 0' : '2px 8px', fontWeight: isClean ? config_1.variables.FONT_WEIGHT.MEDIUM : config_1.variables.FONT_WEIGHT.REGULAR, minWidth: minWidth, display: 'flex', flexWrap: 'nowrap', justifyContent: isClean ? 'flex-end' : 'flex-start' }));
        },
        indicatorSeparator: function () { return ({
            display: 'none',
        }); },
        dropdownIndicator: function (base, _a) {
            var isDisabled = _a.isDisabled;
            return (__assign(__assign({}, base), { display: !withDropdownIndicator || isDisabled ? 'none' : 'flex', alignItems: 'center', color: isClean ? theme.TYPE_LIGHTER_GREY : theme.TYPE_LIGHT_GREY, cursor: 'pointer', path: '', padding: isClean ? 0 : '8px', '&:hover': {
                    color: isClean ? theme.TYPE_LIGHT_GREY : theme.TYPE_DARK_GREY,
                } }));
        },
        menu: function (base) { return (__assign(__assign({}, base), { background: theme.BG_WHITE_ALT, margin: '5px 0', boxShadow: "box-shadow: 0 4px 10px 0 " + theme.BOX_SHADOW_BLACK_20, zIndex: 9 })); },
        menuList: function (base) { return (__assign(__assign({}, base), { boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)', background: theme.BG_WHITE_ALT, borderRadius: '4px', padding: '8px' })); },
        // textTransform does not work in TS with makeStyles => base: any
        groupHeading: function (base) { return (__assign(__assign({}, base), { fontSize: config_1.variables.NEUE_FONT_SIZE.TINY, textTransform: 'initial', margin: '8px', padding: 0 })); },
        group: function (base) { return (__assign(__assign({}, base), { paddingTop: '0px', paddingBottom: '4px' })); },
        option: function (base, _a) {
            var isFocused = _a.isFocused;
            return (__assign(__assign({}, base), { color: theme.TYPE_DARK_GREY, background: isFocused ? theme.BG_WHITE_ALT_HOVER : theme.BG_WHITE_ALT, borderRadius: '5px', padding: '8px', fontSize: config_1.variables.NEUE_FONT_SIZE.SMALL, fontWeight: config_1.variables.FONT_WEIGHT.MEDIUM, '&:hover': {
                    cursor: 'pointer',
                    background: theme.BG_WHITE_ALT_HOVER,
                }, '&:active': {
                    background: theme.BG_WHITE_ALT_HOVER,
                } }));
        },
        input: function (base) { return (__assign(__assign({}, base), { fontSize: config_1.variables.NEUE_FONT_SIZE.NORMAL, color: hideTextCursor ? 'transparent' : theme.TYPE_DARK_GREY, '& input': {
                textShadow: hideTextCursor ? "0 0 0 " + theme.TYPE_DARK_GREY + " !important" : 'none',
            } })); },
        placeholder: function (base) { return (__assign(__assign({}, base), { fontWeight: config_1.variables.FONT_WEIGHT.MEDIUM, fontSize: config_1.variables.NEUE_FONT_SIZE.SMALL, padding: '0 6px' })); },
    });
};
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", ";\n\n    ", "\n\n    .react-select__single-value {\n        position: static;\n        transform: none;\n    }\n"], ["\n    width: ", ";\n\n    ",
    "\n\n    .react-select__single-value {\n        position: static;\n        transform: none;\n    }\n"])), function (props) { return (props.width ? props.width + "px" : '100%'); }, function (props) {
    return !props.isClean && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n        "], ["\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n        "])));
});
var Label = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    min-height: 32px;\n"], ["\n    min-height: 32px;\n"])));
/** Custom Type Guards to check if options are grouped or not */
var isOptionGrouped = function (x) { var _a; return ((_a = x[0]) === null || _a === void 0 ? void 0 : _a.options) !== undefined; };
var Select = function (_a) {
    var _b = _a.hideTextCursor, hideTextCursor = _b === void 0 ? false : _b, _c = _a.withDropdownIndicator, withDropdownIndicator = _c === void 0 ? true : _c, className = _a.className, wrapperProps = _a.wrapperProps, _d = _a.isClean, isClean = _d === void 0 ? false : _d, label = _a.label, width = _a.width, _e = _a.variant, variant = _e === void 0 ? 'large' : _e, _f = _a.noTopLabel, noTopLabel = _f === void 0 ? false : _f, useKeyPressScroll = _a.useKeyPressScroll, _g = _a.isSearchable, isSearchable = _g === void 0 ? false : _g, _h = _a.minWidth, minWidth = _h === void 0 ? 'initial' : _h, _j = _a.borderWidth, borderWidth = _j === void 0 ? 2 : _j, _k = _a.borderRadius, borderRadius = _k === void 0 ? 4 : _k, props = __rest(_a, ["hideTextCursor", "withDropdownIndicator", "className", "wrapperProps", "isClean", "label", "width", "variant", "noTopLabel", "useKeyPressScroll", "isSearchable", "minWidth", "borderWidth", "borderRadius"]);
    var selectRef = react_1.useRef(null);
    var theme = utils_1.useTheme();
    // values used for custom scroll-search behavior
    var lastKeyPressTimestamp = react_1.useRef(0); // timestamp at which last keyPress event occurred
    var searchedTerm = react_1.useRef(''); // string which the user wants to find
    // customize control to pass data-test attribute
    var Control = function (controlProps) { return (react_1.default.createElement(react_select_1.components.Control, __assign({}, controlProps, { innerProps: __assign(__assign({}, controlProps.innerProps), { 'data-test': props['data-test'] + "/input" }) }))); };
    // customize options to pass data-test attribute
    var Option = function (optionProps) { return (react_1.default.createElement(react_select_1.components.Option, __assign({}, optionProps, { innerProps: __assign(__assign({}, optionProps.innerProps), { 'data-test': props['data-test'] + "/option/" + optionProps.value }) }))); };
    var findOption = function (options, query) {
        // Option that will be returned
        var foundOption;
        // Save how far is the query from the beginning of option label (e.g. index of "c" in "Bitcoin" is 3)
        // This way I can give priority to options which START with the query. (Otherwise I would just return first option that CONTAINS searched term)
        var lowestIndexOfFirstOccurrence = Infinity;
        // Loop over all options
        for (var i = 0; i < options.length; i++) {
            // Find where in the option the query is located (returns -1 if not found)
            var indexOfFirstOccurrence = options[i].label
                .toLowerCase()
                .indexOf(query.toLowerCase());
            // If the query was found and it is closer to the beginning than the closes match so far, set new foundOption.
            // (This ensures that if I press "B", I return the first option STARTING with "B", not the first option CONTAINING "B")
            if (indexOfFirstOccurrence >= 0 &&
                indexOfFirstOccurrence < lowestIndexOfFirstOccurrence) {
                lowestIndexOfFirstOccurrence = indexOfFirstOccurrence;
                foundOption = options[i];
            }
        }
        // returns "undefined" if no option was found
        return foundOption;
    };
    var scrollToOption = function (option) {
        if (selectRef.current) {
            // I found a way how to scroll on and option in this tutorial: https://github.com/JedWatson/react-select/issues/3648
            selectRef.current.select.scrollToFocusedOptionOnUpdate = true;
            selectRef.current.select.setState({
                focusedValue: null,
                focusedOption: option,
            });
        }
    };
    var onKeyDown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var charValue, currentTimestamp, timeSincePreviousKeyPress, options, optionsToSearchThrough_1, optionToFocusOn, lastOption;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!useKeyPressScroll) return [3 /*break*/, 2];
                    charValue = String.fromCharCode(e.keyCode);
                    currentTimestamp = new Date().getTime();
                    timeSincePreviousKeyPress = currentTimestamp - lastKeyPressTimestamp.current;
                    // Save current timestamp to lastKeyPressTime variable
                    lastKeyPressTimestamp.current = currentTimestamp;
                    // If user didn't type anything for 0.8 seconds, set searchedValue to just pressed key, otherwise add the new value to the old one
                    if (timeSincePreviousKeyPress > 800) {
                        searchedTerm.current = charValue;
                    }
                    else {
                        searchedTerm.current += charValue;
                    }
                    if (!selectRef.current) return [3 /*break*/, 2];
                    options = selectRef.current.select.props.options;
                    if (!(options && options.length > 1)) return [3 /*break*/, 2];
                    optionsToSearchThrough_1 = [];
                    if (isOptionGrouped(options)) {
                        // Options are nested. Loop through all of the sub-categories and concatenate them into one array
                        // Condition is based on the format of the first item,
                        // I am not sure if it is possible to have both grouped and ungrouped items at the same time
                        // if so than this is not going to work very well, but it can be fixed easily (just check each item if it is a group or not, and adjust the typeguard to type the item instead of whole options array)
                        options.forEach(function (o) {
                            optionsToSearchThrough_1 = optionsToSearchThrough_1.concat(o.options);
                        });
                    }
                    else {
                        // If the options aren't divided into sub-categories, you can use the default options array that is present on "selectRef"
                        optionsToSearchThrough_1 = options;
                    }
                    optionToFocusOn = findOption(optionsToSearchThrough_1, searchedTerm.current);
                    lastOption = optionsToSearchThrough_1[optionsToSearchThrough_1.length - 1];
                    if (!(optionToFocusOn && lastOption)) return [3 /*break*/, 2];
                    /*
                    Here we first scroll to the last option in option-list and then we scroll to the focused option.

                    The reason why I want to scroll to the last option first is, that I want the focused item to
                    appear on the top of the list - I achieve that behavior by scrolling "from bottom-to-top".
                    The default scrolling behavior is "from top-to-bottom". In that case the focused option appears at the bottom
                    of options list, which is not a great UX.

                    If we don't require the focused option to be on top, just delete 'await scrollToOption(lastOption);'
                    */
                    // 1. scroll to the last option first and wait
                    return [4 /*yield*/, scrollToOption(lastOption)];
                case 1:
                    /*
                    Here we first scroll to the last option in option-list and then we scroll to the focused option.

                    The reason why I want to scroll to the last option first is, that I want the focused item to
                    appear on the top of the list - I achieve that behavior by scrolling "from bottom-to-top".
                    The default scrolling behavior is "from top-to-bottom". In that case the focused option appears at the bottom
                    of options list, which is not a great UX.

                    If we don't require the focused option to be on top, just delete 'await scrollToOption(lastOption);'
                    */
                    // 1. scroll to the last option first and wait
                    _a.sent();
                    // 2. scroll to the selected option
                    scrollToOption(optionToFocusOn);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(Wrapper, __assign({ className: className, width: width, isClean: isClean }, wrapperProps),
        !noTopLabel && react_1.default.createElement(Label, null, label),
        react_1.default.createElement(react_select_1.default, __assign({ ref: selectRef, onKeyDown: onKeyDown, classNamePrefix: "react-select", styles: selectStyle(isSearchable, withDropdownIndicator, variant, hideTextCursor, isClean, minWidth, borderRadius, borderWidth, theme), isSearchable: isSearchable }, props, { components: __assign({ Control: Control, Option: Option }, props.components) }))));
};
exports.Select = Select;
var templateObject_1, templateObject_2, templateObject_3;
